import { TrackingContainer } from '@mc/visibility'
import { Section } from 'components/Section'
import { trackInstructorQuoteViewed } from '../events'
import { useInstructorQuoteExperiment } from '../hooks'
import { InstructorQuote } from './InstructorQuote'

export const InstructorQuoteSection = () => {
  const { quote, isVariant } = useInstructorQuoteExperiment()

  if (!isVariant || !quote) return null

  return (
    <Section noAnimation>
      <TrackingContainer
        onFirstVisible={() => trackInstructorQuoteViewed(quote.quote)}
      >
        <InstructorQuote quote={quote} />
      </TrackingContainer>
    </Section>
  )
}
